import { TESTIMONIALS } from "../lib/brand";
import { Quote } from "lucide-react";

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 lg:py-32 bg-navy-800">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid lg:grid-cols-3 gap-12 items-start">
          <div className="lg:col-span-1">
            <p className="uppercase tracking-[0.2em] text-xs font-semibold text-gold mb-4">In their words</p>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-tight">
              Trusted where <span className="gold-text">decisions</span> are made
            </h2>
          </div>

          <div className="lg:col-span-2">
            {TESTIMONIALS.map((t, i) => (
              <figure
                key={i}
                data-testid={`testimonial-${i}`}
                className="relative bg-white/[0.04] backdrop-blur-md border border-white/10 p-10 lg:p-12 hover:border-gold/40 transition-colors"
              >
                <Quote className="w-12 h-12 text-gold/40 mb-6" />
                <blockquote className="font-display text-xl sm:text-2xl text-slate-100 leading-relaxed">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-8 pt-6 border-t border-white/10">
                  <div className="font-display text-lg text-white">{t.name}</div>
                  <div className="text-sm text-gold">{t.role}</div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
